import { BooleanField, BooleanInput, Datagrid, DateField, Edit, FunctionField, List, NumberField, SaveButton, SimpleForm, TextField, TextInput, Toolbar, useRecordContext } from "react-admin";
import { Box, Typography, Paper, Divider, Chip } from "@mui/material";

export const AppointmentList = () => (
    <List 
        sort={{ field: "appointment_datetime", order: 'DESC'}}
        perPage={25}
    >
        <Datagrid>
            <DateField source="appointment_datetime" label="Дата и время" 
                showTime
                options={{
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                }}
            >
            </DateField>
            <TextField source="doctor.fio" label="Врач" />
            <TextField source="patient.fio" label="Пациент" />
            <TextField source="patient.email" label="email" />
            <TextField source="patient.phone" label="Телефон" />
            <NumberField source="price" label="Цена" />
            <BooleanField source="paid" label="Оплачено" />
        </Datagrid>
    </List>
);

const AppointmentTitle = () => {
  const record = useRecordContext();
  const formatDate = (dateString) => {    
    if (!dateString) return "";
    return new Date(dateString).toLocaleString('ru-RU', {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  }
  return <span>{record ? `Запись на прием к врачу ${record.doctor.fio} ${formatDate(record.appointment_datetime)}` : "Запись на прием"}</span>;
};

const CustomToolbar = () => (
    <Toolbar>
        <SaveButton />
        {/* DeleteButton не включен */}
    </Toolbar>
);

const ReadOnlyTextInput = (props) => (
    <TextInput
        {...props}
        readOnly
        sx={{
            '& .MuiInputBase-input.Mui-readOnly': {
                color: 'rgba(0, 0, 0, 0.87)',
                WebkitTextFillColor: 'rgba(64, 64, 64, 0.87)',
            },
            '& .MuiInputBase-root.Mui-readOnly': {
                backgroundColor: 'transparent',
            },
            '& .MuiInputBase-root.Mui-readOnly fieldset': {
                borderColor: 'rgba(0, 0, 0, 0.23)',
            },
            '&:hover .MuiInputBase-root.Mui-readOnly fieldset': {
                borderColor: 'rgba(0, 0, 0, 0.87)', // темнеет при наведении
            }
        }}
    />
);

// const ExtraQuestionsAnswers = () => {
//   const record = useRecordContext();
//   if (!record?.extra_questions_answers) return null;
//   const answers = record.extra_questions_answers;
//   return (
//     <>
//       {Object.entries(answers).map(([question, answer]) => (
//         <FunctionField
//           label={question}
//           render={() => `${question}: ${answer}` || '—'}
//         />
//       ))}
//     </>
//   );
// };

const ExtraQuestionsAnswers = () => {
  const record = useRecordContext();
  
  if (!record || !record.extra_questions_answers) {
    return null;
  }
  
  const extraAnswers = record.extra_questions_answers;
  
  if (typeof extraAnswers !== 'object' || Array.isArray(extraAnswers)) {
    return null;
  }
  
  const entries = Object.entries(extraAnswers);
  
  if (entries.length === 0) {
    return null;
  }
  
  return (
    <Box sx={{ mt: 3, mb: 2 }}>
      <Paper variant="outlined" sx={{ p: 2, bgcolor: '#fafafa' }}>
        {entries.map(([question, answer], index) => (
          <Box key={question}>
            {index > 0 && <Divider sx={{ my: 2 }} />}
            <Box>
              <Typography variant="subtitle2" color="primary" gutterBottom>
                {question}
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  pl: 2, 
                  py: 1,
                  bgcolor: '#fff',
                  borderRadius: 1,
                  whiteSpace: 'pre-wrap'
                }}
              >
                {answer || <em style={{ color: '#999' }}>Нет ответа</em>}
              </Typography>
            </Box>
          </Box>
        ))}
      </Paper>
    </Box>
  );
};

export const AppointmentEdit = () => (
    <Edit title={<AppointmentTitle />}>
        <SimpleForm toolbar={<CustomToolbar />}>
            <ReadOnlyTextInput source="patient.fio" label="Пациент" />
            <ReadOnlyTextInput source="patient.email" label="email" />
            <ReadOnlyTextInput source="patient.phone" label="Телефон" />
            <ReadOnlyTextInput source="complaints" label="Жалобы" />
            <BooleanInput source="paid" label="Оплачено" />
            <ExtraQuestionsAnswers />
        </SimpleForm>
    </Edit>
);